import { render, staticRenderFns } from "./EtapasProspectoGuia.vue?vue&type=template&id=315c867e&scoped=true&"
import script from "./EtapasProspectoGuia.vue?vue&type=script&lang=js&"
export * from "./EtapasProspectoGuia.vue?vue&type=script&lang=js&"
import style0 from "./EtapasProspectoGuia.vue?vue&type=style&index=0&id=315c867e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c867e",
  null
  
)

export default component.exports